import React, { useState, useMemo } from "react";
import "./DrinksList.css";
import ExtrasModal from "./ExtrasModal";

export default function DrinksList({ bebidas = [] }) {
  const [selectedDrink, setSelectedDrink] = useState(null);

  // 🔥 Orden alfabético profesional (respeta acentos en español)
  const bebidasOrdenadas = useMemo(() => {
    return [...bebidas].sort((a, b) =>
      a.name.localeCompare(b.name, "es", { sensitivity: "base" }),
    );
  }, [bebidas]);

  const openModal = (drink) => {
    setSelectedDrink({
      ...drink,
      extras: drink.extras || [],
      Acompanamientos: drink.Acompanamientos || [],
    });
  };

  const closeModal = () => {
    setSelectedDrink(null);
  };

  return (
    <div className="drinks-container">
      <h2 className="drinks-title">Bebidas</h2>

      {bebidasOrdenadas.map((drink) => (
        <div key={drink.id} className="drink-row">
          <div>
            <strong>{drink.name}</strong>

            {drink.description && (
              <p className="drink-desc">{drink.description}</p>
            )}
          </div>

          <div className="drink-actions">
            <span className="drink-price">${drink.price.toLocaleString()}</span>

            <button className="drink-add" onClick={() => openModal(drink)}>
              Agregar
            </button>
          </div>
        </div>
      ))}

      {selectedDrink && (
        <ExtrasModal
          dish={{
            ...selectedDrink,
            id: selectedDrink.id,
          }}
          onClose={closeModal}
        />
      )}
    </div>
  );
}
